module.exports = __webpack_public_path__ + "static/media/Avatar_12.87e962fb.svg";